import Vue from "vue";
import Router from "vue-router";

const _import = require("./_import_" + process.env.NODE_ENV);

Vue.use(Router);

import Main from "@/view/frame/Main";
import BenchMain from "@/view/frame/Bench";
import SIMMain from "@/view/frame/SIMMain";

export const routes = [
	// {
	// 	path: '/test',
	// 	component: Main,
	// 	// redirect: "/test/home",
	// 	children: [
	// 		{
	// 			path: "",
	// 			name: "",
	// 			component: _import('maintain/light/alarm/List1')
	// 		}
	// 	]
	// },
	{
		path: "/icon",
		component: _import("demo/Icon")
	},
	{
		path: "/radio",
		component: _import("demo/Radio")
	},
	{
		path: "/planTable",
		component: _import("demo/treeTable/Plan")
	},
	{
		path: "/treeTable",
		component: _import("demo/treeTable/Index")
	},
	{
		path: "/progress",
		component: _import("demo/Progress")
	},
	{
		path: "/async",
		component: _import("demo/Index")
	},
	{
		path: "/slot1",
		component: _import("demo/Slot1")
	},
	{
		path: "/slot2",
		component: _import("demo/Slot2")
	},
	{
		path: "/slot3",
		component: _import("demo/Slot3")
	},
	{
		path: "/vTree",
		component: _import("demo/VTree")
	},
	{
		path: "/upload",
		component: _import("demo/FileUpload")
	},
	{
		path: "/drag",
		component: _import("demo/drag/Drag")
	},
	{
		path: "/date",
		component: _import("demo/Date")
	},
	{
		path: "/svg",
		component: _import("demo/Svg")
	},
	{
		path: "/shop",
		component: _import("demo/shop/Index")
	},
	{
		path: "/platformSelect",
		component: _import("frame/PlatformSelect")
	},
	{
		path: "/login",
		component: _import("frame/Login")
	},
	{
		path: "/account",
		component: _import("account/Index")
	},
	{
		// 个人设置
		path: "/setting",
		component: Main,
		redirect: "/setting/home",
		children: [
			{
				path: "home",
				name: "/setting/home",
				component: _import("setting/Home")
			},
			{
				path: "preference",
				name: "/setting/preference",
				component: _import("setting/Preference")
			}
		]
	},
	{
		// 注册系列
		path: "/reg",
		component: _import("frame/Front"),
		redirect: "/reg/1",
		children: [
			{
				path: "1",
				name: "/reg/1",
				component: _import("account/reg1")
			},
			{
				path: "2",
				name: "/reg/2",
				component: _import("account/reg2")
			},
			{
				path: "3",
				name: "/reg/3",
				component: _import("account/reg3")
			},
			{
				path: "4",
				name: "/reg/4",
				component: _import("account/reg4")
			}
		]
	},
	{
		// 忘记密码
		path: "/rePassword",
		component: _import("frame/Front"),
		redirect: "/rePassword/1",
		children: [
			{
				path: "1",
				name: "/rePassword/1",
				component: _import("account/rePassword1")
			},
			{
				path: "2",
				name: "/rePassword/2",
				component: _import("account/rePassword2")
			},
			{
				path: "3",
				name: "/rePassword/3",
				component: _import("account/rePassword3")
			}
		]
	},
	{
		path: "/client", // 客户
		component: Main,
		redirect: "/client/home",
		children: [
			{
				path: "home",
				name: "/client/home",
				component: _import("client/Home")
			},
			{
				path: "clue",
				name: "/client/clue",
				component: _import("client/Clue")
			},
			{
				path: "customer",
				name: "/client/customer",
				component: _import("client/Customer")
			}
		]
	},
	{
		path: "/maintain", // 运维
		component: Main,
		redirect: "/maintain/dataCockpit",
		children: [
			// 风能电站
			{
				path: "dataCockpit",
				name: "/maintain/dataCockpit",
				component: _import("maintain/DataCockpit")
			},
			{
				path: "wind/home",
				name: "/maintain/wind/home",
				component: _import("maintain/wind/Home")
			},
			{
				path: "wind/plant",
				name: "/maintain/wind/plant",
				component: _import("maintain/wind/plant/List")
			},
			{
				path: "wind/alarm",
				name: "/maintain/wind/alarm",
				component: _import("maintain/alarm/List")
			},
			{
				path: "wind/device",
				name: "/maintain/wind/device",
				component: _import("maintain/device/Main")
			},
			// 光能电站
			{
				path: "home",
				name: "/maintain/home",
				component: _import("maintain/light/Home")
			},
			{
				path: "plant",
				name: "/maintain/plant",
				component: _import("maintain/light/plant/List")
			},
			{
				path: "light/alarm",
				name: "/maintain/light/alarm",
				component: _import("maintain/alarm/List")
			},
			{
				path: "light/device",
				name: "/maintain/light/device",
				component: _import("maintain/device/Main")
			},
			{
				path: "noPermisson",
				name: "noPermisson",
				component: _import("frame/NoPermissionSub")
			}
			// {
			// 	path: "storage",
			// 	name: "storage",
			// 	component: null
			// }
		]
	},
	{
		path: "/bench", // 工作台
		name: "bench",
		component: BenchMain,
		children: [
			{
				path: "evaluation",
				name: "/bench/evaluation",
				component: _import("bench/evaluation/Index")
			},
			{
				path: "approval",
				name: "/bench/approval",
				component: _import("bench/approval/Index")
			}
		]
	},
	{
		path: "/application", // 应用
		name: "application",
		component: Main,
		redirect: "/application/index",
		props: {
			showSide: false
		},
		children: [
			{
				path: "index",
				name: "/application/index",
				component: _import("application/Index")
			},
			{
				path: "screen",
				name: "/application/screen",
				component: _import("application/display/Screen")
			},
			{
				path: "electricity/home",
				name: "/application/electricity/home",
				component: _import("application/electricity/Home")
			},
			{
				path: "electricity/setting",
				name: "/application/electricity/setting",
				component: _import("application/electricity/Set")
			},
			{
				path: "inspect", // 体检
				name: "/application/inspect",
				component: _import("application/inspect/Inspect")
			},
			{
				path: "inspect/:report", // 再次体检(多报告页面)
				name: "applicationID",
				component: _import("application/inspect/Inspect")
			},
			{
				path: "inspect/:id/:name", // 再次体检（单报告页面）
				name: "inspectBySingle",
				component: _import("application/inspect/Inspect")
			},
			{
				path: "report",
				name: "/application/report",
				component: _import("application/report/Report")
			},
			{
				// sim卡充值
				path: "sim",
				name: "/application/sim",
				component: _import("application/sim/Index")
			},
			{
				path: "maintenance", // 维保记录
				name: "/application/maintenance",
				component: _import("application/maintenance/Home")
			},
			{
				path: "network", // 组网
				name: "/application/network",
				component: _import("application/network/Index")
			},
			{
				// 保险
				path: "insurance",
				name: "/application/insurance",
				component: _import("application/Insurance")
			},
			{
				path: "distributions",
				name: "/application/distributions",
				component: _import("application/distributions/Index")
			},
			{
				// 虚拟气象站
				path: "virtualWeatherStation",
				name: "/application/virtualWeatherStation",
				component: _import("application/VirtualWeatherStation/Index")
			},
			{
				path: "ivcurve",
				name: "/application/ivcurve",
				component: _import("application/ivcurve/Ivcurve")
			},
			{
				path: "deviceMap",
				name: "/application/deviceMap",
				component: _import("application/deviceMap/Index")
			},
			{
				//设备控制
				path: "deviceControl",
				name: "/application/deviceControl",
				component: _import("application/deviceControl/Index")
			},
			{
				path: "noPermisson",
				name: "noPermisson",
				component: _import("frame/NoPermissionSub")
			}
		]
	},
	// 请注意大屏和单体大屏都是重新打开新页面
	{
		path: "/application/screen/view",
		name: "/application/screen/view",
		component: _import("application/display/ScreenView")
	},
	{
		path: "/application/screen/monomer",
		name: "/application/screen/monomer",
		component: _import("application/display/Monomer")
	},
	{
		path: "/project", // 项目
		component: Main,
		redirect: "/project/home",
		children: [
			{
				path: "home",
				name: "/project/home",
				component: _import("project/Home")
			},
			{
				path: "project/list",
				name: "/project/project/list",
				component: _import("project/project/List")
			}
		]
	},
	{
		path: "/manage", // 管理
		component: Main,
		redirect: "/manage/memberAuth/groupMember",
		children: [
			{
				path: "provider",
				name: "groupMember",
				component: _import("manage/provider/index")
			},
			{
				path: "memberAuth/groupMember",
				name: "groupMember",
				component: _import("manage/memberAuth/GroupMember")
			},
			{
				path: "memberAuth/role",
				name: "role",
				component: _import("manage/memberAuth/Role")
			},
			{
				path: "memberAuth/functional",
				name: "functional",
				component: _import("manage/memberAuth/Functional")
			},
			{
				path: "district/district",
				name: "district",
				component: _import("manage/district/District")
			},
			{
				path: "district/timeZone",
				name: "timeZone",
				component: _import("manage/district/TimeZone")
			},
			{
				path: "memberAuth/roles",
				name: "roles",
				component: _import("manage/memberAuth/Roles")
			},
			{
				path: "tag",
				name: "tag",
				component: _import("manage/tag/TagManage")
			},
			{
				path: "external/relation",
				name: "externalRelation",
				component: _import("manage/external/Relation")
			},
			{
				path: "external/roles",
				name: "externalRoles",
				component: _import("manage/external/Roles")
			},
			{
				path: "message",
				name: "message",
				component: _import("manage/message/Home")
			},
			{
				path: "message/box",
				name: "messageBox",
				component: _import("manage/message/Box")
			},
			{
				path: "noPermisson",
				name: "noPermisson",
				component: _import("frame/NoPermissionSub")
			}
		]
	},
	{
		path: "/device", // 设备
		component: Main,
		redirect: "/device/home",
		children: [
			{
				path: "home",
				name: "/device/home",
				component: _import("device/Home")
			},

			// {	//接入
			// 	path: "device/list",
			// 	name: "/device/jr",
			// 	component: _import('device/jr/List')
			// },
			// {	//产品
			// 	path: "device/product",
			// 	name: "/device/product",
			// 	component: _import('device/product/List')
			// },
			{
				// 设备
				path: "device",
				name: "/device/device",
				component: _import("device/device/List")
			},
			{
				// 操作审计
				path: "operationalAudit",
				name: "/device/operationalAudit",
				component: _import("device/operationalAudit/List")
			},

			{
				path: "noPermisson",
				name: "noPermisson",
				component: _import("frame/NoPermissionSub")
			}
		]
	},
	// {
	// 	path: '/', //根地址设置
	// 	component: Main,
	// 	redirect: '/maintain'
	// },
	{
		path: "/notFound",
		component: _import("frame/NotFound")
	},
	{
		path: "/noPermission",
		component: _import("frame/NoPermission")
	},
	{
		path: "/sim",
		component: Main,
		redirect: "/sim/purch"
	},
	{
		path: "/simLogin",
		component: _import("frame/SIMLogin")
	},
	{
		// 产品
		path: "/product",
		component: Main,
		redirect: "/product/List",
		children: [
			{
				// 采购操作
				path: "List",
				name: "/product/List",
				component: _import("product/List")
			},
			{
				path: "batchTask",
				name: "batchTask",
				component: _import("device/batchTask/index")
			},
			{
				// 固件管理
				path: "firmware",
				name: "/product/firmware",
				component: _import("device/firmware/List")
			},
			{
				// 固件管理
				path: "orderManagement",
				name: "/product/orderManagement",
				component: _import("device/orderManagement/List")
			},
			{
				path: "infoMaintenance",
				name: "/product/infoMaintenance",
				component: _import("device/infoMaintenance/List")
			}
			// ,
			// {
			// 	path: 'collectorFastConfig',
			// 	name: '/product/collectorFastConfig/list',
			// 	component: _import('collectorFastConfig/List')
			// }
		]
	},
	{
		// 卡管理
		path: "/sim/card",
		component: Main,
		redirect: "/sim/card/purch",
		children: [
			{
				// 采购操作
				path: "/sim/card/purch",
				component: SIMMain,
				redirect: "/sim/card/purch/check",
				children: [
					{
						path: "check",
						name: "check",
						component: _import("sim/card/purch/Check")
					}
				]
			},
			{
				// 生产操作
				path: "/sim/card/production",
				component: SIMMain,
				redirect: "/sim/card/production/outstorage",
				children: [
					{
						path: "outstorage",
						name: "outstorage",
						component: _import("sim/card/production/Outstorage")
					},
					{
						path: "receive",
						name: "receive",
						component: _import("sim/card/production/Receive")
					},
					{
						path: "restorage",
						name: "restorage",
						component: _import("sim/card/production/Restorage")
					},
					{
						path: "cardtest",
						name: "cardtest",
						component: _import("sim/card/production/CardTest")
					},
					{
						path: "endproductinstorage",
						name: "endproductinstorage",
						component: _import(
							"sim/card/production/EndProductInStorage"
						)
					},
					{
						path: "semifinishedoutstorage",
						name: "semifinishedoutstorage",
						component: _import(
							"sim/card/production/SemiFinishedOutStorage"
						)
					},
					{
						path: "returnorexchange",
						name: "returnorexchange",
						component: _import(
							"sim/card/production/ReturnOrExchange"
						)
					}
				]
			},
			{
				// 库管操作
				path: "/sim/card/keeper",
				component: SIMMain,
				redirect: "/sim/card/keeper/instorage",
				children: [
					{
						path: "instorage",
						name: "instorage",
						component: _import("sim/card/keeper/Instorage")
					},
					{
						path: "card",
						name: "card",
						component: _import("sim/card/keeper/Card")
					},
					{
						path: "card/cardchoose",
						name: "card/cardchoose",
						component: _import("sim/card/keeper/CardChoose")
					},
					{
						path: "outcheck",
						name: "outcheck",
						component: _import("sim/card/keeper/Outcheck")
					},
					{
						path: "scrap",
						name: "scrap",
						component: _import("sim/card/keeper/Scrap")
					}
				]
			},
			{
				// 产品库管操作
				path: "/sim/card/product",
				component: SIMMain,
				redirect: "/sim/card/product/delivery",
				children: [
					{
						path: "delivery",
						name: "delivery",
						component: _import("sim/card/product/Delivery")
					},
					{
						path: "redelivery",
						name: "redelivery",
						component: _import("sim/card/product/Redelivery")
					},
					{
						path: "returnlib",
						name: "returnlib",
						component: _import("sim/card/product/ReturnLib")
					}
				]
			},
			{
				// 运营操作
				path: "/sim/card/operation",
				component: SIMMain,
				redirect: "/sim/card/operation/lookover",
				children: [
					{
						path: "lookover",
						name: "lookover",
						component: _import("sim/card/operation/Lookover")
					},
					{
						path: "cutcard",
						name: "cutcard",
						component: _import("sim/card/operation/Cutcard")
					},
					{
						path: "scrapcheck",
						name: "scrapcheck",
						component: _import("sim/card/operation/Scrapcheck")
					},
					{
						path: "change",
						name: "change",
						component: _import("sim/card/operation/Change")
					}
				]
			},
			{
				// 运营操作
				path: "/sim/card/aftersale",
				component: SIMMain,
				redirect: "/sim/card/aftersale/returnback",
				children: [
					{
						path: "returnback",
						name: "returnback",
						component: _import("sim/card/aftersale/ReturnBack")
					},
					{
						path: "changecard",
						name: "changecard",
						component: _import("sim/card/aftersale/ChangeCard")
					}
				]
			}
		]
	},
	// { path: '*', redirect:(stage.type.c?"/platformSelect":'/login') }
	{
		path: "*",
		redirect: to => {
			let newPath = "";
			if (stage.setting.loc.replaceUrl) {
				$.each(stage.setting.loc.replaceUrl, function() {
					// 遍历匹配
					if (this.from.indexOf(to.path) >= 0) newPath = this.to;
				});
			}
			if (newPath) {
				// 匹配到
				if (
					newPath.substr(0, 4) == "http" ||
					newPath.substr(0, 2) == "//"
				) {
					// http链接直接跳转
					location.replace(newPath);
				} else location.replace("//" + location.host + newPath);
			} else return stage.type.c ? "/platformSelect" : "/login"; // 匹配不到走默认逻辑
		}
	}
];
// $.each(stage.setting.loc.replaceUrl,function(){
// 	routes.unshift({
// 		path:this.from,
// 		redirect:to=>{trace(to)
// 			this.to
// 		}
// 	});
// });
// trace(routes)

export default new Router({
	mode: "history",
	base: stage.loc.baseRouter,
	linkActiveClass: "active", // 设置路由激活菜单的class
	// scrollBehavior: () => ({ y: 0 }),
	routes
});



// WEBPACK FOOTER //
// ./src/router/index.js